import { Carousel } from '@alto-avios/alto-ui'
import { ContentfulCardLegacy } from '@reward-platform/contentful'
import React from 'react'
import { SearchTabQuery } from '~/schemas/searchPageParams'
import { InteractivePod } from '../Pod'
import style from './InteractivePodsCarousel.module.scss'

type Props = {
  cards: ContentfulCardLegacy[]
  product: SearchTabQuery
}

export function InteractivePodsCarousel({ cards, product }: Props) {
  return (
    <div className={style.wrapper} data-testid="interactive-pods-carousel">
      <Carousel
        itemsPerPage={{ base: 1.25, sm: 1.25, md: 2.25, lg: 2.25 }}
        spaceBetweenItems={28}
        hideDots
        hideDisabledArrow
        carouselWrapperClassName={style.wrapper}
        itemWrapperClassName={style.pod_wrapper}
      >
        {cards.map((card) => (
          <InteractivePod key={card.heading} card={card} product={product} />
        ))}
      </Carousel>
    </div>
  )
}
